import React, { Component, Fragment } from 'react';
import './manageSkillPath.scss';
import { getAllSkills, getSearchSkills, changeSkillStatus, createCustomSkill, updateCustomSkill } from '../../../ActionCreators/AdminAction/manageSkillpathAction';
import { getPlans, showWarning, closeSubModal } from '../../../ActionCreators/AdminAction/accountAction';
import { clearErrors } from '../../../ActionCreators/errorAction';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Switch from 'react-switch';
import Modal from "react-bootstrap/Modal";
import Snackbar from '@mui/material/Snackbar';
import { BallBeat, TopicLoader } from '../../../Loader/loader';
import WarningModal from '../../../utils/Expiremodal/warningModal';
const languages = [{ label: 'English', value: 'en' }, { label: 'Hindi', value: 'hi' }, { label: 'Spanish', value: 'es' }];
const maxChar = 75;

class ManageSkills extends Component {
    state = {
        isAddSkill: false,
        page: 1,
        isCreate: false,
        createSkillpath: true,
        type: null,
        langauage: '',
        langText: '',
        imageName: '',
        imageUrl: '/images/empty-image.svg',
        name: '',
        edit: false,
        chars_left: 75,
        intialKey: 0,
        langArr: [{ key: 0, language: languages, value: '', lang: '' }],
        checkDisabled: true,
    }

    componentDidMount = async () => {
        await this.props.getPlans();
        await this.props.getAllSkills();
        this.setState({
            createSkillpath: this.props.plans?.features?.filter(el => el.feature === 'Create custom learning paths')[0]?.allow
        })
    }






    openAddSkill = async () => {
        this.setState({
            isAddSkill: true,
            edit: false
        })
    }

    goBack = () => {
        this.setState({
            isAddSkill: false,
            name: ''
        })
    }

    goToSkillpath = (details) => {
        console.log(details)
        this.props.history.push({
            pathname: '/manage-skillpath',
            state: { details, direct: false }
        })
    }

    handleChange = (id, active) => {
        this.props.changeSkillStatus(id, active);
    }

    onChangeName = (val) => {
        const charCount = val.length;
        const charLength = maxChar - charCount;
        this.setState({ name: val, nameError: '', chars_left: charLength });
    }


    selectLanguage = (key, val) => {
        const langArr = this.state.langArr.slice();
        langArr[key].lang = val;
        this.setState({
            langArr,
            langError: ''
        })
    };

    changeLangText = (key, val) => {
        const langArr = this.state.langArr.slice();
        langArr[key].value = val;
        this.setState({
            langArr,
            langError: ''
        })
    }

    addRow = () => {
        const { langArr } = this.state
        if (langArr.length >= languages?.length) {
            this.setState({
                successMsg: true,
                successMessageText: 'all languages selected'
            })
        }
        else {
            this.setState({
                intialKey: langArr.length,
                // checkDisabled: true,
                langArr: langArr.concat([{ key: langArr.length, language: this.getfilterLang(languages, this.state.langArr), value: '', lang: '' }]),
            }, () => {

            })
        }
    }

    getfilterLang = (A, B) => {
        const A1 = A.filter(b => {
            let indexFound = B.findIndex(a => (a.lang === b.value));
            return indexFound === -1;
        })
        return A1
    }


    handleRemoveShareholder = idx => () => {
        this.setState({
            langArr: this.state.langArr.filter((s, sidx) => idx !== sidx)
        }, () => {
            if (this.state.langArr[this.state.langArr.length - 1].value !== '') {
                this.setState({
                    checkDisabled: false
                })
            }
            const answersns = this.state.langArr.map(answer => {
                if (idx < answer.key) return { key: answer.key - 1, language: answer.language, lang: answer.lang, value: answer.value }
                return answer
            })
            this.setState({
                langArr: answersns
            })
        });
    };

    changeImage = (e) => {
        if (e.target.files[0].size > 2097152) {
            this.setState({
                successMsg: true,
                successMessageText: "The file size cannot exceed 2MB",
            });
        } else {
            const file = this.refs.uploadImg.files[0];
            const reader = new FileReader();

            reader.onloadend = () => {
                this.setState({
                    imageUrl: reader.result,
                });
            };
            if (file) {
                reader.readAsDataURL(file);
                this.setState({
                    imageUrl: reader.result,
                    imageName: file.name,
                    image: file,
                    update: true,
                    checkDisabled: false
                });
            } else {
                this.setState({
                    imageUrl: "",
                    imageName: "",
                    update: false
                });
            }
        }
    }

    checkArrObj = (arr) => {
        const validation = arr.every(item => (item.lang && item.value));
        return validation
    }

    saveSkill = async () => {
        if (this.state.name === '') {
            this.setState({
                nameError: 'Name cannot empty'
            })
        }
        else if (this.checkArrObj(this.state.langArr) === false) {
            this.setState({
                langError: 'Please Select language'
            })
        }
        else if (this.state.image === '') {
            this.setState({
                imageErr: 'Image cannot empty'
            })
        }
        else {
            this.setState({
                nameError: '',
                imageErr: '',
                textError: '',
                isLoading: true
            })
            const data = new FormData();
            data.append('title', this.state.name);
            data.append('image', this.state.image);
            data.append('language', JSON.stringify(this.state.langArr.map(el => [{ value: el.value, lang: el.lang }][0])));
            await this.props.createCustomSkill(data, this.state.name);
            this.setState({
                isAddSkill: false,
                isLoading: false,
                langArr: [{ key: 0, language: languages, value: '', lang: '' }]
            })
            await this.props.getAllSkills();
        }

    }

    editSkill = (el) => {
        this.setState({
            isAddSkill: true,
            edit: true,
            skillId: el._id,
            name: el.title,
            langArr: el?.alternate ? el?.alternate.map((el, i) => [{ value: el.value, lang: el.lang, key: i, language: languages }][0]) : null,
            image: el.image,
            imageUrl: el.image
        })
    }


    updateSkill = async () => {
        console.log(this.state.name, this.state.langArr, this.state.image)
        if (this.state.name === '') {
            this.setState({
                nameError: 'Name cannot empty'
            })
        }
        else if (this.checkArrObj(this.state.langArr) === false) {
            this.setState({
                langError: 'Please Select language'
            })
        }
        else {
            this.setState({
                nameError: '',
                imageErr: '',
                textError: '',
                isLoading: true
            })
            const data = new FormData();
            data.append('_id', this.state.skillId)
            data.append('title', this.state.name);
            typeof this.state.image === 'object' && data.append('image', this.state.image);
            data.append('language', JSON.stringify(this.state.langArr.map(el => [{ value: el.value, lang: el.lang }][0])));
            await this.props.updateCustomSkill(data, this.state.name);
            this.setState({
                isAddSkill: false,
                isLoading: false,
                langArr: [{ key: 0, language: languages, value: '', lang: '' }]
            })
            await this.props.getAllSkills();
        }

    }

    snackClosed = () => {
        this.props.clearErrors();
        this.setState({
            successMsg: false,
            successMessageText: ''
        })
    }

    componentWillUnmount = () => {
        this.timer = null;
    };

    handleSearchSkill = (val) => {
        clearTimeout(this.timer);
        this.setState({
            query: val,
        },
            async () => {
                this.timer = setTimeout(this.getSearch, 500);
            }
        );
    };

    getSearch = async () => {
        await this.props.getSearchSkills(this.state.query);
    };

    openSearchSkill = () => {
        this.props.history.push({ pathname: '/manage-skillpath', state: { direct: true } })
    }



    render() {
        const { isAddSkill, edit } = this.state
        const { isSkillLoading, allSkills, theme, successEnable, successMessage, successMessageText } = this.props

        return (
            <div className='manage-skillpath-holder'>
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successMessage}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={successEnable}
                    onClose={() => this.snackClosed()}
                    message={successMessageText}
                    autoHideDuration={4000}
                />
                <Snackbar
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center', }}
                    open={this.state.successMsg}
                    onClose={() => this.snackClosed()}
                    message={this.state.successMessageText}
                    autoHideDuration={4000}
                />
                {
                    !isAddSkill ?
                        <Fragment>
                            <div className='d-flex justify-content-between align-items-end'>
                                <div>
                                    <h1>Custom Skills</h1>
                                    <p>Skills that you have customized for your organization.</p>
                                </div>
                                {window.innerWidth > 767 &&
                                    <div className='d-flex align-items-center'>
                                        <button style={{ backgroundColor: theme.bgColor }} className='custom-btn' onClick={this.state.createSkillpath ? this.openAddSkill : this.props.showWarning}>Add Custom Skill</button>&nbsp;&nbsp;
                                        <button style={{ backgroundColor: theme.bgColor }} className='custom-btn' onClick={this.state.createSkillpath ? this.openSearchSkill : this.props.showWarning}>Create Custom Skillpath</button>
                                    </div>
                                }
                            </div>
                            <div style={{ marginTop: 6, width: window.innerWidth > 767 ? '' : '95%', borderBottom: '2px solid #e7c15f' }}></div>
                            {window.innerWidth < 767 && <button style={{ backgroundColor: theme.bgColor }} className='custom-btn w-100 mt-2' onClick={this.state.createSkillpath ? this.openAddSkill : this.props.showWarning}>Create Custom Skills</button>}
                            <div className="elite-skill-search mt-2">
                                <div className="has-search">
                                    <span className="form-control-feedback">
                                        <img src="/images/search.svg" width="20px" height="20px" alt="" />
                                    </span>
                                    <input
                                        id="search"
                                        autoComplete="off"
                                        className="form-control"
                                        placeholder="Search skills"
                                        value={this.state.query}
                                        onChange={(e) => this.handleSearchSkill(e.target.value)}
                                    />
                                </div>
                            </div>
                            <div className='mt-2'>
                                {/* <InfiniteScroll
                                    dataLength={skills?.length} //This is important field to render the next data
                                    next={this.fetchData}
                                    hasMore={true}
                                > */}
                                {
                                    isSkillLoading ?
                                        <TopicLoader /> :
                                        allSkills !== undefined && allSkills?.length > 0 ? (
                                            allSkills.map((el) => {
                                                return (
                                                    <div key={el._id} className="skill-list"
                                                        onClick={() => this.goToSkillpath(el)}
                                                    >
                                                        <div className="skill-items" style={{ paddingRight: 70 }}>
                                                            <div>
                                                                {window.innerWidth > 767 && (
                                                                    <img
                                                                        src={el?.image || '/images/sample.svg'}
                                                                        alt=""
                                                                        loading="lazy"
                                                                        width={88}
                                                                        height={56}
                                                                        style={{ verticalAlign: "middle", borderRadius: 6 }}
                                                                        onError={(e) => {
                                                                            if (
                                                                                e.target.src !==
                                                                                "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png"
                                                                            ) {
                                                                                e.target.onerror =
                                                                                    "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                                e.target.src =
                                                                                    "https://elite-skill-images.s3.ap-south-1.amazonaws.com/Competitive+Intelligence.png";
                                                                            }
                                                                        }}
                                                                    />
                                                                )}{" "}
                                                                &nbsp;&nbsp;&nbsp;
                                                                <section className='text-left'>
                                                                    {el.title}
                                                                </section>
                                                            </div>
                                                            <div className='d-flex align-items-center' >
                                                                <div className="d-flex align-items-center" >
                                                                    <section>
                                                                        <h6>{el.customskillpath}</h6>
                                                                        <p>Skillpath</p>
                                                                    </section>
                                                                </div>
                                                            </div>

                                                            <div style={{ width: window.innerWidth > 767 ? '7%' : '15%', cursor: 'pointer', textAlign: 'center' }}>
                                                                {el.custom ?
                                                                    <p onClick={(e) => {
                                                                        e.preventDefault()
                                                                        e.stopPropagation()
                                                                        this.handleChange(el._id, el.active)
                                                                    }}> <Switch
                                                                            onChange={(e) => console.log(e)}
                                                                            width={30}
                                                                            height={16}
                                                                            uncheckedIcon={false}
                                                                            checkedIcon={false}
                                                                            onColor='#00B24B'
                                                                            checked={el.active} /><br />
                                                                        {el.active ? 'Active' : 'Inactive'}
                                                                    </p> :
                                                                    <p>NA</p>}
                                                            </div>
                                                            <div className="d-flex align-items-center" >
                                                                {el.custom ?
                                                                    <p ><img src='/images/edit.svg' alt='' onClick={(e) => {
                                                                        e.preventDefault()
                                                                        e.stopPropagation()
                                                                        this.editSkill(el)
                                                                    }} /></p>
                                                                    : <p>NA</p>
                                                                }
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })
                                        ) : (
                                            <div className="empty-list">
                                                <img src="/images/empty.png" alt="" />
                                                <p>There is no customized skills.</p>
                                            </div>
                                        )}
                                {/* </InfiniteScroll> */}
                            </div>

                        </Fragment> :
                        <div className='add-skill'>
                            <h2 onClick={this.goBack}><img src='/images/back1.svg' width='20px' alt='' /> &nbsp;&nbsp;{edit ? 'Edit Skill' : 'Add Skill'}</h2>
                            <p>Fields marked * are mandatory</p>
                            <div className='form-group mt-2'>
                                <label>Skill Name*
                                    <aside className='float-right'>{this.state.chars_left}</aside>
                                </label>
                                <input className='form-control mt-2 ' maxLength={maxChar} value={this.state.name.charAt(0).toUpperCase() + this.state.name.slice(1)} onChange={(e) => this.onChangeName(e.target.value)} />
                                <small>{this.state.nameError}</small>
                            </div>
                            {
                                this.props.edit ?
                                    <div className='form-group mt-2'>
                                        <label>Skill Id*
                                            {/* <aside className='float-right'>{this.state.chars_left}</aside> */}
                                        </label>
                                        <input className='form-control mt-2 ' disabled maxLength={this.state.maxChar} value={this.state.id} />
                                    </div>
                                    : null
                            }
                            <div className='mt-3'>
                                <label>Skill Langauage and Text*</label>
                                <div className='d-flex align-items-end'>
                                    <div>
                                        {
                                            this.state.langArr?.map((el, i) => {
                                                return (
                                                    <div key={el._id} className='duration d-flex mt-2'>
                                                        <select disabled={!!this.props.edit} className='form-control' value={el.slang} onChange={(e) => this.selectLanguage(el.key, e.target.value)}>
                                                            <option hidden>Langauage</option>
                                                            {
                                                                el.language.map(el => {
                                                                    return (
                                                                        <option key={el.value} value={el.value}>{el.label}</option>
                                                                    )
                                                                })
                                                            }
                                                        </select>
                                                        &nbsp;&nbsp;
                                                        <input type='text' placeholder='Text in Language' value={el.value} className='form-control' onChange={(e) => this.changeLangText(el.key, e.target.value)} />&nbsp;
                                                        {
                                                            i === 0 ? null :
                                                                <img src="/images/delete.svg" className='cursor-pointer' onClick={this.handleRemoveShareholder(i)} alt='' width={window.innerWidth > 767 ? '25px' : '20px'} />
                                                        }
                                                    </div>
                                                )
                                            })
                                        }
                                    </div>
                                    {this.props.edit ? null : <img src='/images/plus-circle.svg' alt='' className='cursor-pointer' onClick={() => this.addRow()} />}

                                </div>
                                <small>{this.state.langError}</small>
                                <small>{this.state.textError}</small>
                            </div>
                            <div className='mt-3'>
                                <label>Skill Cover Image*</label>
                                <p style={{ marginTop: 5 }}>This is the default image. </p>
                                <div className='d-flex align-items-center '>
                                    {
                                        this.state.image ?
                                            <div className='program-image'>
                                                <img src={this.state.imageUrl} alt='' width='139px' height='78px' />
                                            </div> :
                                            <div className='program-image'>
                                                <img src={this.state.imageUrl} alt='' />
                                            </div>
                                    }

                                    <div className='d-flex flex-column mt-3 position-relative'>
                                        <span> <img src='/images/upload-icon.svg' alt='' /> &nbsp;Upload Image &nbsp; <small>{this.state.imageName}</small>
                                            <input type='file' ref="uploadImg" className='file-upload'
                                                name="selectedFile" accept="image/png, image/jpeg" onChange={this.changeImage} />
                                        </span>
                                    </div>
                                </div>
                                <small>{this.state.imageErr}</small>
                            </div>
                            <hr />
                            <div className='save-btn mt-2'>
                                {
                                    edit ?
                                        <button onClick={this.updateSkill} >
                                            {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>
                                        :
                                        <button onClick={() => this.saveSkill()}
                                            disabled={this.state.checkDisabled === true}
                                        >
                                            {this.state.isLoading ? <div className='ballbeat'><BallBeat color="#fff" /></div> : 'Save'}</button>

                                }
                                <button onClick={this.goBack}>Cancel</button>
                            </div>
                        </div>
                }

                {/* ########## Confirm Delete modal ############### */}
                <Modal
                    show={this.state.isCreate}
                    size="lg"
                    aria-labelledby="contained-modal-title-vcenter"
                    centered
                    // onHide={this.handleCloseModal}
                    dialogClassName={"confirm-modal"}
                >
                    <div
                        className={
                            window.innerWidth > 767 ? "p-3 text-center" : "p-2 text-center"
                        }
                    >
                        <h1 style={{ fontSize: window.innerWidth > 767 ? 18 : 15 }}>
                            A customized skill path already exists for this skill. Do you really want to create another one?
                        </h1>
                        <div className="save-btn">
                            <div className="save-btn">
                                <button style={{ backgroundColor: theme?.bgColor }} onClick={() => this.redirectSkillTopic(this.state.type)}>Yes</button> &nbsp;&nbsp;
                                <button onClick={this.closeModal}>No</button>
                            </div>
                        </div>
                    </div>
                </Modal>

                {/* //warning modal */}
                <WarningModal
                    planAlert={this.props.alert}
                    closeSubModal={this.props.closeSubModal}
                />
            </div >
        )
    }
}

const mapStateToProps = (state) => {
    const { isSkillLoading, allSkills } = state.manageSkillpath
    const { successMessageText, successMessage, successEnable } = state.error
    const { theme, plans, alert } = state.account
    return {
        isSkillLoading, allSkills, theme, plans, alert, successMessageText, successMessage, successEnable
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({ getPlans, getAllSkills, getSearchSkills, createCustomSkill, updateCustomSkill, changeSkillStatus, showWarning, closeSubModal, clearErrors }, dispatch)
}


export default connect(mapStateToProps, mapDispatchToProps)(ManageSkills)

